/* External */
import {
  memo, useEffect, useRef, useState,
} from 'react';

/* Components */
import Epg from '../../../components/Epg/Epg';
import LanderPage from '../../../components/LanderPage';
// It should be removed from the code when pages v4 is the final version.
import UpSellBanner from '../../../components/UpSellBanner';
import ScrollIntoViewIfFocused from '../../../components/ScrollIntoViewIfFocused';

/* Utils */
import useOnLeftArrowPress from '../../../hooks/useOnLeftArrowPress';
import { useOpenSidebar } from '../../../providers/SidebarStateContext';
import { PageType } from '../../../utils/constants';
import { useCountry, useIsBrazil } from '../../../providers/ConfigProvider';
import useSportsChannels from '../../../hooks/useSportsChannels';
import { useGtmLocalContext } from '../../../providers/GtmLocalProvider';
import { GTM_CATEGORIES, GTM_EVENT_NAMES, GTM_SUBCATEGORIES } from '../../../utils/googleTags';
import { ScrollPosition } from '../../../components/ScrollView';
import { getIsCurableBannerActive } from '../../../utils/functions';

/* Hooks */
import useGetUpSellBannerMessage from '../../../hooks/useGetUpSellBannerMessage';

function Sports() {
  const isBrazil = useIsBrazil();
  const country = useCountry();
  const goToSidebar = useOpenSidebar();
  const isCurableBannerActive = getIsCurableBannerActive();

  const [initialScrollPositionEpg, setInitialScrollPositionEpg] = useState(
    () => Number.parseFloat(sessionStorage.getItem('offsetEpg')) || 0,
  );

  const handleLeftArrowPress = useOnLeftArrowPress(goToSidebar);

  const sportsCategory = isBrazil
    ? import.meta.env.VITE_SPORTS_CATEGORY_BR
    : import.meta.env.VITE_SPORTS_CATEGORY;
  const channels = useSportsChannels(sportsCategory);

  const { commonTaggingEvent } = useGtmLocalContext();
  const tagsMountRef = useRef(true);

  // It should be removed from the code when pages v4 is the final version.
  const {
    showUpSellBanner,
  } = useGetUpSellBannerMessage(isCurableBannerActive) || {};

  useEffect(() => {
    if (tagsMountRef.current && country) {
      commonTaggingEvent({
        category: GTM_CATEGORIES.LIVE_CATALOG_SPORTS_KIDS_PAGE_DATA,
        subCategory: GTM_SUBCATEGORIES.PAGES.SPORTS_PAGE,
        eventName: GTM_EVENT_NAMES.PAGE_VIEW,
      });
      tagsMountRef.current = false;
    }
  }, [commonTaggingEvent, country]);

  return (
    <LanderPage pageId={PageType.SPORTS}>
      {channels.size > 0 && (
        <Epg
          channels={channels}
          onLeftArrowPress={handleLeftArrowPress}
          pageId={PageType.SPORTS}
          initialScrollPosition={initialScrollPositionEpg}
          setInitialScrollPosition={setInitialScrollPositionEpg}
          withoutFilter
        />
      )}
      {showUpSellBanner && (
        <ScrollIntoViewIfFocused position={ScrollPosition.CENTER}>
          <UpSellBanner />
        </ScrollIntoViewIfFocused>
      )}
    </LanderPage>
  );
}

export default memo(Sports);
